import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { TRANSITION_DURATION } from '../constants'
import { sleep } from '../utilities/general'

export function useModalClose(navigateTo: string, inline?: boolean) {
  const [open, setOpen] = useState(true)
  const navigate = useNavigate()

  const handleClose = async () => {
    if (inline) return
    setOpen(false)
    await sleep(TRANSITION_DURATION)
    navigate(navigateTo)
  }

  return { open, handleClose }
}
